import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { SidebarStateKey } from 'applications/GSP/layouts/MainLayout/components/Sidebar/store';

import type { SidebarAnimatedComponentsState } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';

export const Wrapper = styled(Box, {
  shouldForwardProp: prop => prop !== SidebarStateKey.Opened,
})<SidebarAnimatedComponentsState>(({ theme, opened }) => ({
  alignSelf: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  margin: theme.spacing(0.5, 3, 2),

  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(0.5, 1, 2),
    opacity: opened ? 1 : 0,
  },
}));
